import { Show } from "solid-js";
import { OfferConstruct } from "~/server/types/brand";

function getOfferText(offerConstruct?: OfferConstruct): string | undefined {
  if (!offerConstruct) return undefined;

  if (offerConstruct.type === "ONE_TIME_REWARD") {
    const details = offerConstruct.oneTimeRewardDetails;
    if (!details) return undefined;
    if (details.amountUnit === "PERC") return `${details.value}% off`;
    if (details.amountUnit === "ABS") return `₹${details.value} off`;
  }

  if (offerConstruct.type === "SUBSCRIPTION_REWARD") {
    const first = offerConstruct.subscriptionRewardDetails?.[0]?.rewardDetails;
    if (!first) return undefined;
    if (first.amountUnit === "PERC") return `${first.value}% off`;
    if (first.amountUnit === "ABS") return `₹${first.value} off`;
  }

  return undefined;
}

export function OfferPill(props: { offerConstruct?: OfferConstruct }) {
  const text = () => getOfferText(props.offerConstruct);
  return (
    <Show when={text()}>
      <div class="pointer-events-none absolute right-2 top-2 z-[1] rounded-full bg-white px-2 py-[2px] text-label-semi-bold text-black shadow-sm">
        {text()}
      </div>
    </Show>
  );
}
